var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter1Design2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 137,
    viewBox: "0 0 175 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.144 84.8529L141.063 70.2692L167.356 116.751L123.306 137L102.223 88.0631L81.0078 136.956L37.0313 116.591L63.3968 70.5887L10.7242 84.635L0 39.01L54.3797 29.946L9.54235 -0.775757L40.2121 -37.6419L81.1683 -2.34453L78.2356 -55L126.998 -54.9419L123.919 -2.30095L164.963 -37.1044L195.56 -0.557877L150.635 30.0622L205 39.2569L194.144 84.8529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1Design2);
export default __webpack_public_path__ + "static/media/footer_1_design_2.4db96708cd5225f1e7219918538b754d.svg";
export { ForwardRef as ReactComponent };